import React, { Component } from 'react';
import { Button } from "react-bootstrap";
import closeIcon from "../../images/arch-close.png";
import { t } from "../helper/ClientAppLocalizer"

export class Modal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: props.isOpen,
            closeButtonText: props.closeButtonText ? props.closeButtonText : t("Close")
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
        if (this.props.closed != null) {
            this.props.closed();
        }
    }

    render() {

        return (
            <div id="{this.props.id}">
                
                {this.state.modalIsOpen ? (
                    <div style={{
                        position: 'fixed', width: '100%', height: '100%', top: 0,
                        left: 0, right: 0, bottom: 0, margin: 'auto', backgroundColor: 'rgba(0,0,0, 0.5)', textAlign: 'left'
                    }} >
                        <div style={{
                            position: 'absolute', left: '25%', right: '25%', top: '25%',
                            margin: 'auto', background: 'white'
                        }}>
                            <div style={{
                                height: 36, border: 'none', backgroundColor: '#f1f3f3',
                                backgroundImage: 'none', minHeight: 35
                            }}>
                                <span style={{
                                    paddingRight: 45, whiteSpace: 'nowrap', overflowWrap: 'normal',
                                    padding: '3px 95px 6px 15px', margin: 0, width: '100%', position: 'absolute', left: 0,
                                    boxSizing: 'border-box', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block',
                                    fontSize: '1.3em', fontFamily: "'Open Sans', sans-serif"
                                }}>{this.props.title}</span>

                                <span style={{ position: 'absolute', right: 0, top: 0, height: 36, border: 'none' }}>

                                    <img src={closeIcon} alt="" onClick={this.closeModal}
                                        style={{
                                            position: 'relative', top: 3, right: 0, display: 'inline-block',
                                            backgroundPosition: '2px 0', paddingRight: 6, cursor: 'pointer'
                                        }} />
                                </span>
                            </div>
                            <div style={{ margin: 20, minHeight: 60 }}>
                                <p>{this.props.text}</p>
                            </div>
                            <div style={{
                                height: 36, border: 'none', backgroundColor: '#f1f3f3',
                                backgroundImage: 'none', minHeight: 50
                            }}>
                                <Button id={this.props.id + "CloseButton"}
                                    style={{ marginTop: 10, marginRight: 5, float: 'right' }}
                                    onClick={this.closeModal}>{this.state.closeButtonText}</Button>
                            </div>

                        </div>
                    </div>
                ) : ''}
            </div>
        );
    }
}
